import { Injectable } from '@angular/core';
import { Environment } from './environment';
import { Observable, BehaviorSubject } from 'rxjs';


@Injectable({providedIn: 'root'})
export class BusinessNavEnvironmentService {
  private environment$$: BehaviorSubject<Environment> = new BehaviorSubject<Environment>(1);
  public environment$: Observable<Environment>;

  constructor() {
    this.environment$ = this.environment$$.asObservable();
  }

  setEnvironment(env: Environment): void {
    this.environment$$.next(env);
  }

  getEnvironment(): Environment {
    return this.environment$$.getValue();
  }
}
